import { useFeedback, useTranslation } from "@opendash/core";
import { saveTicket } from "../../creation";

export const useSaveTicketState = () => {
  const t = useTranslation();
  const { handleLoadingFeedback } = useFeedback();

  async function saveTicketState(stateId: string, ticketId: string) {
    await handleLoadingFeedback(
      () => saveTicket({ existingTicketId: ticketId, state: stateId }),
      t("maintenance:ticket.state.loading"),
      t("maintenance:ticket.state.success"),
      t("maintenance:ticket.state.error")
    );
  }

  return saveTicketState;
};
